import { DTO__ml_asset_lora_tag_frequency } from '@shared/dto/+model/sd/ml_asset/DTO__ml_asset_lora_tag_frequency';
import { FIELD__token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD__token';
import { useMemo } from 'react';
import { HOOK__ml_asset_lora_get_enabled_and_non_zero_weight } from './HOOK__ml_asset_lora_get_enabled_and_non_zero_weight';

export function HOOK__token_is_lora_tag(field: FIELD__token) {
  const ml_assets_loras = HOOK__ml_asset_lora_get_enabled_and_non_zero_weight(field.meta.node_id);

  const is_lora_tag = useMemo(() => get_is_lora_tag(), [field, ml_assets_loras]);

  function get_is_lora_tag() {
    if (field.is_stub()) return false;

    let configs = ml_assets_loras.map(item => item.config);
    let tags = configs.flatMap(config => config.get_lora__tag_frequency());

    let tag_by_word_map = DTO__ml_asset_lora_tag_frequency.map_by_word(tags);

    return tag_by_word_map.has(field.word_english.get_value());
  }

  return is_lora_tag;
}
